/**
 * Cart bubble live updater.
 *
 * OPO's header inlines the cart bubble markup (snippets/header-left-logo.liquid
 * + header-center-logo.liquid) instead of rendering sections/cart-icon-bubble.liquid,
 * so the Section Rendering API can't be relied on. Instead, after any add-to-cart
 * fires `cart:updated` (variant table, predictive search, single-variant button,
 * product-form fallback), we fetch /cart.js for the authoritative item count and
 * write it into the bubble's count span.
 *
 * Toast is handled by snippets/cart-notification-popup.liquid (existing).
 */
(function () {
  'use strict';

  let inFlight = false;

  function formatMoney(cents, currency) {
    if (typeof cents !== 'number') return '';
    var dollars = (cents / 100).toFixed(2);
    var withCommas = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + withCommas + (currency ? ' ' + currency : '');
  }

  async function refreshBubble() {
    if (inFlight) return;
    inFlight = true;
    try {
      const res = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });
      if (!res.ok) throw new Error('cart.js fetch failed: ' + res.status);
      const cart = await res.json();
      const count = typeof cart.item_count === 'number' ? cart.item_count : 0;

      // OPO inlines the bubble markup so it's always present (even on empty cart).
      document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span[aria-hidden]').forEach(function (el) {
        el.textContent = String(count);
      });

      // Also update the burger/menu drawer cart count if it exists.
      document.querySelectorAll('.menu-drawer__utility-account-cart .cart-count-bubble span[aria-hidden]').forEach(function (el) {
        el.textContent = String(count);
      });

      // Update the visually-hidden announcement text too (accessibility).
      const itemsLabel = count === 1 ? '1 item' : count + ' items';
      document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span:not([aria-hidden])').forEach(function (el) {
        el.textContent = itemsLabel;
      });

      // Mobile sticky-bar total — outside the cart section, so the section's
      // own re-render won't catch it. Update it here from /cart.js.
      const formatted = formatMoney(cart.total_price, cart.currency);
      document.querySelectorAll('[data-mobile-bar-total]').forEach(function (el) {
        el.textContent = formatted;
      });
    } catch (e) {
      console.error('[cart-bubble-updater]', e);
    } finally {
      inFlight = false;
    }
  }

  // Variant table + predictive search + single-variant button all fire this CustomEvent.
  document.addEventListener('cart:updated', refreshBubble);

  // product-form.js publishes via the global pubsub (assets/pubsub.js).
  function trySubscribe() {
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, refreshBubble);
      return true;
    }
    return false;
  }
  if (!trySubscribe()) {
    document.addEventListener('DOMContentLoaded', trySubscribe);
    window.addEventListener('load', trySubscribe);
  }

  // Sync once on the cart page so the sticky bar matches server state even
  // when the cart was modified between the page render and DOM ready (e.g.,
  // user updated qty in another tab).
  function initialSync() {
    if (document.querySelector('[data-mobile-bar-total]')) refreshBubble();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync);
  } else {
    initialSync();
  }
})();
